import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

console.log('process.env.REACT_APP_API_URL: ', process.env.REACT_APP_API_URL);
console.log(client);

export default client